import React, { useState } from "react";
import { auth } from "../firebase/firebase";
import Input from "./Input";
import Button from "./Button";
import "./SignIn.css";

export const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<Error | null>(null);

  const router = {
    push: (path: string) => {
      return path;
    },
  };

  const submit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    setError(null);
    console.log("submitting form");

    auth
      .signInWithEmailAndPassword(email, password)
      .then((_) => {
        setEmail("");
        setPassword("");
        setError(null);
        router.push("/");
      })
      .catch((error: Error) => {
        setError(error);
      });
  };

  const isInvalid = password === "" || email === "";

  return (
    <div className="login-container relative">
      <div className="login-form-wrapper">
        <div className="flex justify-center mb-8">
          <img 
            src="/ogle-logo.png" 
            alt="Ogle Logo" 
            className="h-auto w-[310px]"
          />
        </div>
        <form onSubmit={submit} className="login-form">
          {error && (
            <div className="login-error">
              {error.message}
            </div>
          )}
          <Input
            label="E-pasta adrese"
            type="email"
            value={email}
            onChange={setEmail}
            placeholder="E-pasta adrese"
            error={!!error}
          />
          <Input
            label="Parole"
            type="password"
            value={password}
            onChange={setPassword}
            placeholder="Parole"
            error={!!error}
          />
          <Button
            type="submit"
            disabled={isInvalid}
            fullWidth
          >
            Turpināt
          </Button>
        </form>
      </div>
    </div>
  );
};
